/* eslint-disable */

/*
 * this code is from the chart.js documentation for building a custom tooltip
 * https://www.chartjs.org/docs/latest/configuration/tooltip.html#external-custom-tooltips
 */
function barCenterTooltip(context) {
	const OPACITY_HIDDEN = 0,
		// `this` will be the overall tooltip
		position = this._chart.canvas.getBoundingClientRect();

	// Tooltip Element
	let tooltipEl = document.getElementById("chartjs-tooltip");

	// Create element on first render
	if (!tooltipEl) {
		tooltipEl = document.createElement("div");
		tooltipEl.id = "chartjs-tooltip";
		tooltipEl.innerHTML = "<table></table>";
		document.body.appendChild(tooltipEl);
	}

	// Hide if no tooltip
	if (context.opacity === OPACITY_HIDDEN) {
		tooltipEl.style.opacity = "0";
		return;
	}

	// Set caret Position
	tooltipEl.classList.remove("above", "below", "no-transform");
	if (context.yAlign) {
		tooltipEl.classList.add(context.yAlign);
	} else {
		tooltipEl.classList.add("no-transform");
	}

	function getBody(bodyItem) {
		return bodyItem.lines;
	}

	// Set Text
	if (context.body) {
		const titleLines = context.title || [],
			bodyLines = context.body.map(getBody),
			tableRoot = tooltipEl.querySelector("table");
		let innerHtml = "<thead>";

		titleLines.forEach(function (title) {
			innerHtml += "<tr><th>" + title + "</th></tr>";
		});
		innerHtml += '</thead><div class="waste-source-chart-tooltip"><div class="waste-source-stats">';

		bodyLines.forEach(function (body, i) {
			body = body[0].toString().split(": ");
			const colors = context.labelColors[i],
				value = parseFloat(body[1]),
				graphValue = value > 0 && value < 1 ? "<1" : Math.round(value);

			innerHtml +=
				"<h1>" + graphValue + '%</h1> <i style="background: ' + colors.backgroundColor + '"></i><p>' + body[0] + "</p>";
		});
		innerHtml += "</div></div>";

		tableRoot.innerHTML = innerHtml;
	}

	// Display, position, and set styles for font
	tooltipEl.style.backgroundColor = "transparent";
	tooltipEl.style.color = "#000";
	tooltipEl.style.opacity = "1";
	tooltipEl.style.position = "absolute";
	tooltipEl.style.left = position.left + window.pageXOffset + "px";
	tooltipEl.style.top = position.top + window.pageYOffset + "px";
	tooltipEl.style.fontFamily = context._bodyFontFamily;
	tooltipEl.style.fontSize = "16px";
	tooltipEl.style.fontStyle = context._bodyFontStyle;
	tooltipEl.style.pointerEvents = "none";
	tooltipEl.style.width = "100%";
	tooltipEl.style.boxShadow = "initial";
	tooltipEl.style.height = position.height + "px";
}

export const circleChartOptions = {
	title: {
		display: false,
	},
	legend: {
		display: false,
	},
	responsive: true,
	maintainAspectRatio: false,
	animation: {
		easing: "easeInOutQuad",
		duration: 520,
	},
	cutoutPercentage: 85,
	tooltips: {
		backgroundColor: [],
		enabled: false,
		custom: barCenterTooltip,
	},
};
